import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'
import { ISignInEmailVerificationDto } from 'src/types'

const useSendEmailVerification = () => {
  const navigate = useNavigate()

  return useMutation(
    (dto: ISignInEmailVerificationDto) => AuthDataService.sendEmailVerification(dto),
    {
      onSettled: (data) => {
        if (!data) return

        if (data.activation_token) {
          navigate(`/signin/email/${data.activation_token}`)
        }
      },
    },
  )
}

export { useSendEmailVerification }
